import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';

import ironmanImage from 'src/images/ironman.png';
import userImage from 'src/images/user.png';
import supermanImage from 'src/images/superman.png';
import batmanImage from 'src/images/batman.png';
import robinImage from 'src/images/robin.png';
import ringAnim from 'src/images/anim/ring.svg';
import withAuth from 'src/hoc/withAuth';

const apiSearch = '/api/supportStatistics/membersSupportRanking';
const linkToUser = '/dashboard/user/';

class RankingSupport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetMember: 0,
      dateStart: moment().subtract(7, 'day').format('YYYY-MM-DD'),
      dateEnd: moment().format('YYYY-MM-DD'),
      members: undefined,
      columnFiltered: 'ticketsClosed',
      columns: {
        ticketsClosed: 'tickets_closed',
        averageTreatment: 'average_closing_treatment',
        averageCriticity: 'average_criticity',
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChange2 = this.handleDateChange2.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.seeMore = this.seeMore.bind(this);
    this.switchColFilter = this.switchColFilter.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateStart: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }
  handleDateChange2(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateEnd: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  componentDidMount() {
    let search = {
      employees: true,
      orderBy: this.state.columnFiltered,
      dateStart: this.state.dateStart,
      dateEnd: this.state.dateEnd,
      limit: itemsPerPage['ranking_commercial'],
    };
    this.refreshSearch(search, 0);
  }

  refreshSearch(search, offsetNb) {
    this.setState({ pending: true });
    let queryURL = apiSearch;
    search['offset'] = offsetNb * itemsPerPage['ranking_commercial'];
    let data = 'data=' + encodeURIComponent(JSON.stringify(search));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['membersRanking']) {
            this.setState({
              offsetMember: offsetNb, // increment or reset the current offset
              members: offsetNb > 0 ? this.state.members.concat(data['membersRanking']) : data['membersRanking'],
              hasMoreMember: data['hasMore'],
            });
          }
          this.setState({
            pending: false,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch ranking-support search: ' + error);
        }.bind(this)
      );
  }

  seeMore() {
    let search = {
      employees: true,
      orderBy: this.state.columnFiltered,
      dateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      dateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      limit: itemsPerPage['ranking_commercial'],
    };
    this.refreshSearch(search, this.state.offsetMember + 1);
  }

  switchColFilter(newCol) {
    this.setState({
      columnFiltered: newCol,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    let search = {
      employees: true,
      orderBy: this.state.columnFiltered,
      dateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      dateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      limit: itemsPerPage['ranking_commercial'],
    };

    if (nextState.columnFiltered !== this.state.columnFiltered) {
      search.orderBy = nextState.columnFiltered;
      this.refreshSearch(search, 0);
    } else if (nextState.dateStart != this.state.dateStart) {
      search.dateStart = moment(nextState.dateStart).format('YYYY-MM-DD');
      this.refreshSearch(search, 0);
    } else if (nextState.dateEnd != this.state.dateEnd) {
      search.dateEnd = moment(nextState.dateEnd).format('YYYY-MM-DD');
      this.refreshSearch(search, 0);
    }

    return true;
  }

  render() {
    const { members } = this.state;

    let noMembers = members && members.length === 0 ? <span>Aucun résultat sur la période.</span> : '';

    return (
      <div id='stat-container'>
        <img className={'right-hero'} src={ironmanImage} />
        <div id='stat-content'>
          <div id='stat-content-header' className='alignHorizontal'>
            <h2>Nos héros de Scaleed City</h2>
            <div id='stat-aside-header-dates' className='alignHorizontal'>
              <DatePicker
                calendarContainer={this}
                name='dateStart'
                value={this.state.dateStart}
                onChange={this.handleDateChange}
                dateFormat='YYYY-MM-DD'
              />
              <span className='icon icon-arrow-right'></span>
              <DatePicker
                calendarContainer={this}
                name='dateEnd'
                value={this.state.dateEnd}
                onChange={this.handleDateChange2}
                dateFormat='YYYY-MM-DD'
              />
            </div>
          </div>
          {members && (
            <div className={'row'}>
              <div className={'col-md-4 podium-first'}>
                <div className={'card-user'}>
                  <h5>{members[0] ? members[0].member.label : ''}</h5>
                  <img
                    className={'avatar'}
                    src={
                      members[0] && members[0].member.profile_image ? '/' + members[0].member.profile_image : userImage
                    }
                  />
                  <p className={'ranking-value'}>
                    {members[0] ? members[0][this.state.columns[this.state.columnFiltered]] : ''}
                  </p>
                  <img id='superman' className={'reward'} src={supermanImage} />
                </div>
              </div>
              <div className={'col-md-4 podium-second'}>
                <div className={'card-user'}>
                  <h5>{members[1] ? members[1].member.label : ''}</h5>
                  <img
                    className={'avatar'}
                    src={
                      members[1] && members[1].member.profile_image ? '/' + members[1].member.profile_image : userImage
                    }
                  />
                  <p className={'ranking-value'}>
                    {members[1] ? members[1][this.state.columns[this.state.columnFiltered]] : ''}
                  </p>
                  <img id='batman' className={'reward medal-reward'} src={batmanImage} />
                </div>
              </div>
              <div className={'col-md-4 podium-third'}>
                <div className={'card-user'}>
                  <h5>{members[2] ? members[2].member.label : ''}</h5>
                  <img
                    className={'avatar'}
                    src={
                      members[2] && members[2].member.profile_image ? '/' + members[2].member.profile_image : userImage
                    }
                  />
                  <p className={'ranking-value'}>
                    {members[2] ? members[2][this.state.columns[this.state.columnFiltered]] : ''}
                  </p>
                  <img id='robin' className={'reward'} src={robinImage} />
                </div>
              </div>
            </div>
          )}

          <div id='ranking-list'>
            <table className='table'>
              <thead>
                <tr>
                  <th>
                    <span className={'icon icon-trophy'}></span>
                  </th>
                  <th>Nom</th>
                  <th
                    className={
                      'cursor ' + (this.state.columnFiltered === 'ticketsClosed' ? 'table-cell-selected ' : '')
                    }
                    onClick={() => this.switchColFilter('ticketsClosed')}
                  >
                    Cloturés
                  </th>
                  <th
                    className={
                      'cursor ' + (this.state.columnFiltered === 'averageTreatment' ? 'table-cell-selected ' : '')
                    }
                    onClick={() => this.switchColFilter('averageTreatment')}
                  >
                    Moyenne traitement (jours)
                  </th>
                  <th
                    className={
                      'cursor ' + (this.state.columnFiltered === 'averageCriticity' ? 'table-cell-selected ' : '')
                    }
                    onClick={() => this.switchColFilter('averageCriticity')}
                  >
                    Moyenne criticité
                  </th>
                </tr>
              </thead>
              <tbody>
                {members ? (
                  members.map((data, i) => (
                    <tr key={i}>
                      <td
                        className={
                          'ranking-medal-' + (i === 0 ? 'gold ' : i === 1 ? 'silver ' : i === 2 ? 'bronze ' : '')
                        }
                      >
                        {i <= 2 ? <span className={'icon icon-medal'}></span> : i + 1}
                      </td>
                      <td>
                        <Link to={linkToUser + data.member.user_id}>
                          <span>{data.member.label}</span>
                        </Link>
                      </td>
                      <td
                        className={
                          'cursor ' + (this.state.columnFiltered === 'ticketsClosed' ? 'table-cell-selected ' : '')
                        }
                        onClick={() => this.switchColFilter('ticketsClosed')}
                      >
                        <span>{data.tickets_closed}</span>
                      </td>
                      <td
                        className={
                          'cursor ' + (this.state.columnFiltered === 'averageTreatment' ? 'table-cell-selected ' : '')
                        }
                        onClick={() => this.switchColFilter('averageTreatment')}
                      >
                        <span>{data.average_closing_treatment}</span>
                      </td>
                      <td
                        className={
                          'cursor ' + (this.state.columnFiltered === 'averageCriticity' ? 'table-cell-selected ' : '')
                        }
                        onClick={() => this.switchColFilter('averageCriticity')}
                      >
                        <span>{data.average_criticity}</span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <li className='list-group-item'>Chargement...</li>
                )}
              </tbody>
            </table>
            {this.state.hasMoreMember && (
              <div className='list-see-more'>
                {this.state.pending ? (
                  <img src={ringAnim} />
                ) : (
                  <button onClick={this.seeMore} type='button' className='btn btn-sm btn-outline-success'>
                    <span className=''>Voir plus</span>
                  </button>
                )}
              </div>
            )}
            {noMembers}
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(RankingSupport);
